import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

const StyledInput = styled(Ui.Input)`
  input {
    height: 3.5rem;
    font-weight: 600;

    & + svg {
      top: 1rem;
    }
  }
`;

export { StyledInput };
